// extracted by mini-css-extract-plugin
export var bottomBox = "ring-card-module--bottom-box--lh6sY";
export var container = "ring-card-module--container--5PySL";
export var icon = "ring-card-module--icon--U93Rn";
export var imageBox = "ring-card-module--image-box--qs4pX";
export var link = "ring-card-module--link--hdsNe";
export var radiusBox = "ring-card-module--radius-box--KS7zB";
export var ratio = "ring-card-module--ratio--ze50R";
export var subtitleText = "ring-card-module--subtitle-text--lHX7X";
export var titleBox = "ring-card-module--title-box--ioDDk";